import React from 'react'
import PropTypes from 'prop-types'

import './MonthEventContainer.scss'
import VirtualVisitSecondary from '@scoir/brand-icons/dist/VirtualVisitSecondary'

const MonthEventContainer = ({ children, isVirtual = false }) => (
  <div className="month-event-container-comp">
    {isVirtual ? <VirtualVisitSecondary className="indicator" /> : <span className="dot indicator" />}
    <div className="month-event-summary">{children}</div>
  </div>
)

MonthEventContainer.propTypes = {
  children: PropTypes.node.isRequired,
  isVirtual: PropTypes.bool,
}

export default MonthEventContainer
